import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import SuccessPage from "@/pages/SuccessPage";
import CancelPage from "@/pages/CancelPage";
import AdminPage from "@/pages/AdminPage";
import TermsPage from "@/pages/policies/TermsPage";
import PrivacyPage from "@/pages/policies/PrivacyPage";
import RefundPage from "@/pages/policies/RefundPage";
import ShippingPage from "@/pages/policies/ShippingPage";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/site/CartDrawer";

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/refunds" element={<RefundPage />} />
            <Route path="/shipping" element={<ShippingPage />} />
          </Routes>
        </BrowserRouter>
        <CartDrawer />
      </CartProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
